import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

const head = { "Content-Type": "multipart/form-data" };
const instance2 = axios.create({
  baseURL: apihostname,
  headers: { ...authHeader(), ...head },
});

class uploadfileService {
  deleteForDownload(id) {
    return instance.delete("/delete_for_download/" + id);
  }
  uploadForDownload(body) {
    return instance2.post("/upload_for_download", body);
  }
  uploadsinglefile(body) {
    return instance2.post("/uploadsinglefile", body);
  }
  uploadMastersinglefile(body) {
    return instance2.post("/upload_master_singlefile", body);
  }
  uploadMemberDocFile(body) {
    return instance2.post("/upload_assoc_member_file", body);
  }
  listfile(regid) {
    return instance.post("/listfile", { reg_id: regid });
  }
  listMasterfile(master_id) {
    return instance.post("/list_master_file", { master_id: master_id });
  }
  listAssocMemberFile(body) {
    return instance.post("/list_assoc_member_file", body);
  }
  deletesinglefile(body) {
    return instance.post("/deletesinglefile", body);
  }
  deleteMastersinglefile(body) {
    return instance.post("/delete_master_singlefile", body);
  }
  listDownloadFiles() {
    return instance.get("/list-downloads");
  }
}

export default new uploadfileService();
